export const getErrorMessage = (error) => {
    if (error instanceof Error) {
        return error.message;
    }
    if (typeof error === 'object') {
        return JSON.stringify(error);
    }
    return String(error);
};
//# sourceMappingURL=getErrorMessage.js.map